import { HttpClientJsonpModule, HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from '@core/core.module';
import { SharedModule } from '@shared/shared.module';
import { MenuService } from '@shared/services';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { TokenInterceptorService } from '@shared/services/token-interceptor.service';

@NgModule({
  declarations: [AppComponent],
  imports: [
      BrowserModule,
      AppRoutingModule,
      HttpClientModule,
      HttpClientJsonpModule,
      SharedModule,
      CoreModule,
      BrowserAnimationsModule,
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: environment.production,
      }),
  ],
  providers: [
    [
      { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true },
    ],
    MenuService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
